import { render, staticRenderFns } from "./DataArticle1.vue?vue&type=template&id=729e4fd2&"
import script from "./DataArticle1.vue?vue&type=script&lang=js&"
export * from "./DataArticle1.vue?vue&type=script&lang=js&"
import style0 from "./DataArticle1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports